import { z } from 'zod';

export const AuditRow = z.object({
  at: z.string().datetime(),
  userName: z.string(),
  message: z.string(),
});
export const AuditList = z.object({ rows: z.array(AuditRow) });
export type AuditList = z.infer<typeof AuditList>;
